import { useCallback } from "react"
import { FACTORS_VIEW_EVENTS } from "../analytics/events"

/**
 * Custom hook that provides reusable handlers for factors view table analytics.
 * Encapsulates common logic for tracking table interactions (sort, navigation).
 *
 * @param {Object} params - The parameters object
 * @param {Function} params.track - Analytics track function
 * @returns {Object} Object containing handler functions
 */
export function useFactorsViewTableHandlers({ track }) {
  const handleSortChanged = useCallback((sortMetricId, sortDirection) => {
    track(FACTORS_VIEW_EVENTS.SORT_CHANGED, { sortMetricId, sortDirection })
  }, [track])

  const handleTableNavigationChanged = useCallback((tableLevels) => {
    track(FACTORS_VIEW_EVENTS.TABLE_NAVIGATION_CHANGED, { tableLevels })
  }, [track])

  return {
    handleSortChanged,
    handleTableNavigationChanged,
  }
}
